<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" hidden="true" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <div class="right-menu-group">
          <el-tooltip content="導航搜索" effect="dark" placement="bottom">
            <div class="icon-button search-button" :class="{ 'is-expanded': isSearchExpanded }">
              <search id="header-search" ref="headerSearch" @toggle="handleSearchToggle" />
            </div>
          </el-tooltip>
          <el-tooltip content="全螢幕縮放" effect="dark" placement="bottom">
            <div class="icon-button">
              <screenfull id="screenfull" />
            </div>
          </el-tooltip>
          <el-tooltip content="佈局大小" effect="dark" placement="bottom">
            <div class="icon-button">
              <size-select id="size-select" />
            </div>
          </el-tooltip>
        </div>
      </template>

      <div class="divider" />

      <el-dropdown ref="userDropdown" class="user-menu" trigger="click" @visible-change="handleDropdownVisible">
        <div class="user-info">
          <div class="user-badge">
            <span v-if="TENANT_ID" class="tenant-id">{{ TENANT_NAME || TENANT_ID }}</span>
            <span v-if="TENANT_ID && USERNAME" class="separator">@</span>
            <span v-if="USERNAME" class="username">{{ USERNAME }}</span>
          </div>
          <i class="el-icon-arrow-down" :class="{ 'is-active': dropdownVisible }" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/change-password">
            <el-dropdown-item>
              <i class="el-icon-edit" />
              <span>變更密碼</span>
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="logout">
            <i class="el-icon-switch-button" />
            <span>登出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
// import Notification from '@/components/Notification'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    SizeSelect,
    Search
    // Notification
  },
  data() {
    return {
      dropdownVisible: false,
      isSearchExpanded: false
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'name', 'USERNAME', 'TENANT_ID', 'TENANT_NAME'])
  },
  methods: {
    handleSearchToggle(isExpanded) {
      this.isSearchExpanded = isExpanded
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    handleDropdownVisible(visible) {
      this.dropdownVisible = visible
    },
    logout() {
      this.$confirm('確定要登出系統嗎？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('user/logout').then(() => {
          // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
          this.$router.push(`/login`)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid #f0f2f5;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 20px;
    gap: 8px;

    &:focus {
      outline: none;
    }

    .right-menu-group {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .icon-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;
      color: #606266;

      &:hover {
        background: #f5f7fa;
        color: #42b983;

        ::v-deep {
          .svg-icon,
          .size-icon {
            color: #42b983;
          }
        }
      }

      &:active {
        transform: scale(0.95);
      }

      &.search-button {
        width: auto;
        min-width: 36px;
        padding: 0;
        justify-content: center;
        overflow: visible;

        // 展開前 hover 時保持背景加深（與其他按鈕一致）
        &:hover:not(.is-expanded) {
          background: #f5f7fa;
        }

        // 展開後不需要背景加深
        &.is-expanded {
          background: transparent !important;
        }
      }

      ::v-deep {
        .header-search {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;

          &.show {
            justify-content: flex-start;
          }

          .search-icon {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .screenfull,
        .size-select {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
        }

        .svg-icon {
          font-size: 18px;
          cursor: pointer;
          transition: color 0.2s;
        }

        .search-icon,
        .size-icon {
          font-size: 18px;
        }

        // 確保 hover 時 icon 變色
        .size-select .size-icon {
          color: inherit;
        }

        i {
          font-size: 18px;
        }
      }
    }

    .divider {
      width: 1px;
      height: 24px;
      background: #e4e7ed;
      margin: 0 8px;
    }

    .user-menu {
      margin-left: 4px;

      .user-info {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 12px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
          background: #f5f7fa;
        }

        .user-badge {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 14px;
          line-height: 1.5;
          user-select: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;

          .tenant-id {
            display: inline-flex;
            align-items: center;
            padding: 2px 8px;
            background: #f0f9ff;
            color: #42b983;
            font-size: 12px;
            font-weight: 600;
            border-radius: 4px;
            border: 1px solid rgba(66, 185, 131, 0.2);
            user-select: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
          }

          .separator {
            color: #c0c4cc;
            font-size: 13px;
            font-weight: 300;
            user-select: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
          }

          .username {
            color: #303133;
            font-weight: 500;
            user-select: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
          }
        }

        .el-icon-arrow-down {
          font-size: 12px;
          color: #909399;
          transition: transform 0.2s;

          &.is-active {
            transform: rotate(180deg);
          }
        }
      }
    }

    ::v-deep {
      .el-dropdown-menu {
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border: 1px solid #e4e7ed;
        padding: 4px 0;
      }

      .el-dropdown-menu__item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 16px;
        transition: all 0.2s;

        &:hover {
          background: #f5f7fa;
          color: #42b983;

          i {
            color: #42b983;
          }
        }

        i {
          font-size: 16px;
          color: #909399;
          transition: color 0.2s;
        }

        &.is-disabled {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
